import React, { useEffect, useState } from "react";
import TabelaSimples from "../../../../components/tabelas/simples";
import FilterModal from "../../../../components/filter/Modal";
import functions from "../../../../util/functions";
import reqContaEntrada from "../../../../services/reqMultiTenant/reqContaEntrada";
import Notification from "../../../../components/toast";
import HeaderReport from "../../../../components/header/report";
import HeaderListFilter from "../../../../components/header/report-filter";

function MovimentacaoCaixaAnalitico() {
	const [isFilterOpen, setIsFilterOpen] = useState(false);
	const [dtini, setDtIni] = useState();
	const [dtfim, setDtFim] = useState();
	const [hrIni, setHrIni] = useState("00:00:00");
	const [hrFim, setHrFim] = useState("23:59:59");
	const [idCaixaOuColaborador, setIdCaixaOuColaborador] = useState("%");
	const [nomeColaboradorOuCaixa, setNomeOuColaborador] = useState("TODOS");
	const [isSelectCaixa, setIsSelectCaixa] = useState(true);
	const [loading, setLoading] = useState(false);

	const [listMovimentacao, setListMovimentacao] = useState([]);
	const [recordCount, setRecordCount] = useState("");

	useEffect(() => {
		const agora = new Date();
		const dataFormatada = functions.dateToStrIso(agora);
		setDtIni(dataFormatada);
		setDtFim(dataFormatada);
	}, []);

	function openFilter() {
		setIsFilterOpen(!isFilterOpen);
	}

	function closeFilter() {
		setIsFilterOpen(false);
	}

	const listarReceivePayments = () => {
		let dataini = functions.dateByString(dtini);
		let datafim = functions.dateByString(dtfim);

		dataini = dataini + " " + hrIni;
		datafim = datafim + " " + hrFim;

		setIsFilterOpen(!isFilterOpen);

		const tipo = isSelectCaixa ? "caixa" : "colaborador";
		const valorTipo = idCaixaOuColaborador;

		listarMovimentacao(dataini, datafim, valorTipo, tipo);
	};

	const listarMovimentacao = async (dataIni, dataFim, valortipo, tipo) => {
		try {
			setLoading(true);
			const response = await reqContaEntrada.listContaEntradaContaSaida(tipo, valortipo, dataIni, dataFim);

			const list = response.data.map((mov) => {
				const dataMovimentacao = functions.dateTimeToStrIso8601(mov.datamovimentacao);
				const dataPgto = functions.dateByString(mov.datapgto);
				const avista = mov.avista ? `R$ ${mov.avista}` : "";
				const aprazo = mov.aprazo ? `R$ ${mov.aprazo}` : "";

				return {
					Id: mov.id_conta_entrada,
					Efetuado: avista,
					Pendente: aprazo,
					Movimentação: mov.tipo,
					Descricao: mov.nome,
					Data_Movimentação: dataMovimentacao,
					Tipo: mov.xtipo,
					Banco: mov.banco,
					Caixa: mov.caixa,
					Data_Pagamento: dataPgto,
				};
			});

			setRecordCount(list.length);
			setListMovimentacao(list);
		} catch (error) {
			Notification.showToast({ message: error.message, type: "error" });
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className="mt-page">
			<FilterModal //
				title="Movimentação Financeiro"
				isOpen={isFilterOpen}
				onRequestClose={closeFilter}
				filterName={false}
				filterLate={false}
				dataEHora={true}
				dtini={dtini}
				dtfim={dtfim}
				hrIni={hrIni}
				hrFim={hrFim}
				idCaixaOuColaborador={idCaixaOuColaborador}
				isSelectCaixa={isSelectCaixa}
				setHrIni={setHrIni}
				setHrFim={setHrFim}
				setDtIni={setDtIni}
				setDtFim={setDtFim}
				setIdCaixaOuColaborador={setIdCaixaOuColaborador}
				setIsSelectCaixa={setIsSelectCaixa}
				handleList={listarReceivePayments}
				setNomeOuColaborador={setNomeOuColaborador}
				hideToggle={true}
			/>

			{/* HEADER PADRONIZADO */}
			<header className="flex flex-col bg-white p-2 rounded-sm box-shadow-md mb-6">
				<div className="grid grid-cols-2">
					<div className="col-span-1">
						<HeaderReport title="Movimentação financeiro por caixa" subTitle={nomeColaboradorOuCaixa} />
					</div>
					<div className="col-span-1 flex justify-end mb-2">
						<div className="flex flex-col gap-1">
							<HeaderListFilter
								filterData={{
									origem: {
										label: "Pesquisar por",
										value: "Número do caixa",
									},
									periodo: {
										label: "Período",
										value: `${functions.dateByString(dtini)} ${hrIni} à ${functions.dateByString(dtfim)} ${hrFim}`,
									},
									registros: {
										label: "Registros encontrados",
										value: recordCount || "0",
									},
								}}
							/>
						</div>
					</div>
				</div>

				<div className="col-span-1 flex justify-end items-end mt-2">
					<div className="flex gap-2 h-8">
						<button className="btn btn-sm btn-primary w-32" onClick={openFilter}>
							Filtrar
						</button>
					</div>
				</div>
				<div className="border-bottom mt-3"></div>
			</header>

			<div className="w-full">
				<TabelaSimples
					list={listMovimentacao}
					loading={loading}
					columns={[
						"Id",
						"Efetuado",
						"Pendente",
						"Movimentação",
						"Descricao",
						"Data_Movimentação",
						"Tipo",
						"Banco",
						"Caixa",
						"Data_Pagamento",
					]}
				/>
			</div>
		</div>
	);
}

export default MovimentacaoCaixaAnalitico;
